import { useAnalyticsSales } from '@/api';
import { Heading } from '@/components/atoms';
import { AreaChart } from '@/components/molecules';

interface GrowthChartProps {
  startDate?: string;
  endDate?: string;
}

export const GrowthChart = ({ startDate, endDate }: GrowthChartProps) => {
  const { data } = useAnalyticsSales(startDate, endDate);

  const chartConfig = {
    sales: {
      label: 'Sales',
      color: 'primary',
    },
  };

  return (
    <div className="sm:max-md:row-span-3 sm:max-md:col-span-5 col-span-6 flex flex-col gap-4 justify-between bg-white rounded-md border border-accent p-4 md:p-6">
      <Heading>Growth</Heading>
      <AreaChart
        chartData={data?.chart ?? []}
        chartConfig={chartConfig}
        areaKeys={['sales']}
      />
    </div>
  );
};
